import { Mention } from "@tiptap/extension-mention";
import { VueRenderer } from "@tiptap/vue-3";
import tippy from "tippy.js";
import VariableSuggestions from "./VariableSuggestions.vue";
import VariableView from "./VariableView.vue";
import { VueNodeViewRenderer } from "@tiptap/vue-3";

export const useVariableExtension = async () => {

  const { getVariables } = useWebsiteContent();
  const { data: variables, suspense: variablesSuspense } = getVariables();
  await variablesSuspense();

  return Mention.extend({
    name: "variable",
    selectable: true,
    addOptions() {
      return {
        ...this.parent?.(),
        HTMLAttributes: {
          class: "variable",
        },
        suggestion: {
          char: "$",
          allowSpaces: false,
          command: ({ editor, range, props }) => {
            editor
              .chain()
              .focus()
              .insertContentAt(range, [
                {
                  type: "variable",
                  attrs: props,
                },
                { type: "text", text: " " },
              ])
              .run();
          },
          render: () => {
            let component: VueRenderer;
            let popup: any;

            return {
              onStart: (props: any) => {
                component = new VueRenderer(VariableSuggestions, {
                  props,
                  editor: props.editor,
                });

                popup = tippy("body", {
                  getReferenceClientRect: props.clientRect,
                  appendTo: () => document.body,
                  content: component.element as HTMLElement,
                  showOnCreate: true,
                  interactive: true,
                  trigger: "manual",
                  placement: "bottom-start",
                  zIndex: 500,
                });
              },
              onUpdate: (props) => {
                component?.updateProps(props);

                popup[0].setProps({
                  getReferenceClientRect: props.clientRect,
                });
              },
              onKeyDown: (props) => {
                if (props.event.key === "Escape") {
                  popup[0].hide();
                  return true;
                }

                return component?.ref?.onKeyDown(props);
              },
              onExit: () => {
                popup[0].destroy();
                component.destroy();
              },
            };
          },
          items: ({ query }): { id: string; label: string }[] => {
            return Object.keys(variables.value)
              .filter((key) => key.toLowerCase().includes(query.toLowerCase()))
              .map((key) => ({
                id: key,
                label: key,
              }));
          },
        },
      };
    },
    addNodeView() {
      return VueNodeViewRenderer(VariableView as any);
    },
  });
};
